import styled from 'styled-components'
import colors from '../../_constants/colors'

const trackerBarHeight = 10
const trackerBarRadius = trackerBarHeight / 2
export const S_FormTracker = styled.ol`
  margin: 0;
  padding: 0;
  text-align: left;
  font-size: 14px;

  ol {
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: flex;
    flex-direction: row;
  }

  li {
    flex: 1;
    position: relative;
    &:before {
      position: absolute;
      content: '';
      background-color: #fff;
      height: ${trackerBarHeight + 2}px;
      width: 4px;
      top: -1px;
      right: -2px;
      transform: rotate(20deg);
      z-index: 10;
    }

    &:first-child {
      .tracker-bar {
        border-radius: ${`${trackerBarRadius}px`} 0 0 ${`${trackerBarRadius}px`};
      }
    }

    &:last-child {
      .tracker-bar {
        border-radius: 0 ${`${trackerBarRadius}px`} ${`${trackerBarRadius}px`} 0;
      }
      &:before {
        display: none;
      }
    }

    &:hover:not(.completed):not(.active) {
      .tracker-bar {
        background: ${(props) => props.colors.trackerform || props.colors.primary || colors.TEXT_DARK};
        opacity: 0.5;
      }
      .label {
        color: ${(props) => props.colors.trackerform || props.colors.primary || colors.TEXT_DARK};
        opacity: 0.5;
      }
    }

    &.click {
      cursor: pointer;
    }
  }

  .tracker-bar {
    background: ${colors.GREY};
    height: ${trackerBarHeight}px;
    position: relative;
    transition:
      background-color 0.2s ease-in-out,
      opacity 0.2s ease-in-out;
    z-index: 0;

    &.active,
    &.completed {
      background-color: ${(props) => props.colors.trackerform || props.colors.primary || colors.DEFAULT_PRIMARY};
    }
  }

  .label {
    padding: 5px 2px;
    color: ${colors.LIGHT_GREY};
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    transition:
      color 0.2s ease-in-out,
      opacity 0.2s ease-in-out;
    &.active,
    &.completed {
      font-weight: 400;
      color: ${(props) => props.colors.trackerform || props.colors.primary || colors.TEXT_DARK};
    }
  }

  .step-number {
    padding-right: 3px;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`
